import { render } from "./HotspotPopContainer.vue?vue&type=template&id=132dddc9&scoped=true"
import script from "./HotspotPopContainer.vue?vue&type=script&lang=js"
export * from "./HotspotPopContainer.vue?vue&type=script&lang=js"

import "./HotspotPopContainer.vue?vue&type=style&index=0&id=132dddc9&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132dddc9"]])

export default __exports__